(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryTestingAddDialogController', BatteryTestingAddDialogController);

    BatteryTestingAddDialogController.$inject = ['$stateParams', '$state', 'ipmConstants', '$uibModalInstance', 'entity', 'BatteryTestingService', 'HaqsBatteryService', 'patientId'];

    function BatteryTestingAddDialogController($stateParams, $state, constants, $uibModalInstance, entity, BatteryTestingService, HaqsBatteryService, patientId) {
        var vm = this;
        vm.patientId = patientId;
        vm.haqBattery = entity;
        vm.haqBatteries = null;
        vm.haqBatterySeleted = null;
        vm.departmentSeleted = null;
        vm.clear = clear;
        vm.save = save;
        vm.isSaving = false;
        vm.isInvalidBattery = false;
        vm.departmentTypes = constants.DEPARTMENT_TYPE;

        init();

        function init() {
            getAllBattery();
            vm.departmentSeleted = 'CLINIC';
        }

        function getAllBattery() {
            vm.isLoading = true;

            HaqsBatteryService.getAllBatteryForSelect(constants.DROPDOWN_BATTERIES_TYPE, vm.patientId).then(function (response) {
                vm.haqBatteries = response ? response : [];
                vm.isLoading = false;
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if (vm.isSaving || !vm.departmentSeleted || !vm.haqBatterySeleted || vm.haqBatterySeleted.batteryTestCnt < 1) {
                return;
            }
            vm.isSaving = true;
            vm.haqBattery.department = vm.departmentSeleted;
            vm.haqBattery.id = vm.haqBatterySeleted.id;
            BatteryTestingService.saveBatteryTesting(vm.haqBattery).then(function (res) {
                onSaveSuccess(res);
            }, function errorSave(error) {
                onSaveError(error);
            });
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError(error) {
            vm.isSaving = false;
            if (error.status !== 200) {
                $uibModalInstance.close(error);
            }
        }

        vm.selectBatteriesOnChange = function () {
            if (!vm.haqBatterySeleted || vm.haqBatterySeleted.batteryTestCnt < 1) {
                vm.isInvalidBattery = true;
            } else {
                vm.isInvalidBattery = false;
            }
        };
    }
})();
